import { BalLanguage, BalRegion, initialize } from '@baloise/ds-core';
import * as balIcons from '@baloise/ds-icons';
import { isPlatform } from '@baloise/ds-core';
import { setCookie } from '../utils/cookie';
import { track } from '../utils/utils';

const handleLoad = () => {
  if (window.location.hash) {
    scrollToHash();
  }
};

export const waitForElm = selector => {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(() => {
      const selectorIsThere = document.querySelector(selector);
      const isHydrated = selectorIsThere?.classList.contains('hydrated');
      if (selectorIsThere && isHydrated) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
};

(async () => {
  function addTrackingEvent(event: Event) {
    window.track(event);
  }

  await customElements.whenDefined('bal-app');

  await document
    .querySelector('bal-app')
    .componentOnReady()
    .then(async () => {
      await waitForElm('bal-nav').then((elm: HTMLBalNavElement) => {
        setTimeout(() => {
          const links = elm.querySelectorAll('a[data-tracking-style]');
          links.forEach(link =>
            link.addEventListener('click', event => {
              window.track(event);
            }),
          );

          const observer = new MutationObserver(mutations => {
            for (const mutation of mutations) {
              for (const node of mutation.addedNodes) {
                if (!(node.nodeName === 'BAL-NAV-MENU-FLYOUT')) continue;
                const trackingWrapper: HTMLElement = node as HTMLElement;
                setTimeout(() => {
                  if ((trackingWrapper as HTMLElement).classList.contains('hydrated')) {
                    trackingWrapper.querySelectorAll('a[data-tracking-style]').forEach(trackingElement => {
                      trackingElement.addEventListener('click', addTrackingEvent);
                    });
                  }
                }, 500);
              }
            }
          });
          observer.observe(elm, {
            childList: true,
            subtree: true,
          });
        }, 500);
      });
    });
})();

export const getNavigationHeight = async () => {
  if (document.querySelector('bam-navigation')) {
    const metaNavHeight = await waitForElm('bal-nav-meta-bar').then((elm: HTMLBalNavMetaBarElement) => elm.clientHeight);
    
    if(isPlatform('desktop')) {
      const mainNavHeight = await waitForElm('bal-nav-menu-bar').then((elm: HTMLBalNavMenuBarElement) => elm.clientHeight);
      return metaNavHeight + mainNavHeight;
    }

    return metaNavHeight;
  } else {
    return 0;
  }
};

const scrollToHash = async () => {
  const el = document.getElementById(window.location.hash.slice(1));
  const navHeight = await getNavigationHeight();

  if (el) {
    setTimeout(() => {
      window.scrollTo({ top: el.offsetTop - navHeight });
    }, 100);
  }
};

// expected values from the lang attribute are like 'de' or 'de-CH'
const locale = document.documentElement.lang;
let language = 'de';
let region = 'CH';
if (locale.length == 2) {
  language = locale;
} else if (locale.indexOf('-') == 2 && locale.length == 5) {
  language = locale.substr(0, 2);
  region = locale.substr(3, 2);
}

window.Baloise.locale = locale;
window.Baloise.region = region;
window.Baloise.language = language;

initialize({
  region: region as BalRegion,
  language: language as BalLanguage,
  allowedLanguages: ['de', 'fr', 'it', 'en'],
  icons: { ...balIcons },
});

if ((window as any).Baloise.targetGroupPath) {
  setCookie('targetGroupPath', (window as any).Baloise.targetGroupPath, 90);
}

declare global {
  interface Window {
    Baloise: any;
    dataLayer: any;
    grecaptcha: any;
    track: Function;
  }
}

window.track = function (e) {
  track(e);
};

window.addEventListener('load', handleLoad);
